module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_borogodo-612d2a848b1f776cd733fcff265b738a.png";